// import router from '@/router/index'
// import { setTimeout } from "timers/promises";
export default {
    async loadUser(context){
        let body = {
            "type": "profile"
        }
        return await this.$api.info.allApi(body)
        .then( (response) => {

            if(response.response.message === "INVALID_CREDENTIALS"){
                localStorage.removeItem('profile');
                localStorage.removeItem('tokenExpiration');
            }

            context.commit("user",response.response.profile)
            context.commit("user_files",response.response.files)
            return true
        })
    },

    /* EDIT */
    async editUser(context,body){
        body.type = "edit_profile"

        let t = await this.$api.info.allApi(body)
        .then( (response) => {
            context.commit("change_key_user",response)
            // router.replace("/account")
            return response
        })
        return t
    },

    /* Upload */
    async uploadFiles(context,formdata){
        
        return await this.$api.info.uploadFiles(formdata)
        .then( async () => {
            return await context.dispatch("loadUser")
        })

    },
    async uploadImgProfile(context,formdata){

        return await this.$api.info.uploadFiles(formdata)
        .then( async (response) => {

            if(response.response.result[0].replace("/home/tv4r2pys/public_html", "")){
                let img_url = response.response.result[0].replace("/home/tv4r2pys/public_html", "")
                await context.dispatch("editUser", {immagineProfiloPreferito: img_url})
            }

            return await context.dispatch("loadUser")
        })

    },
    async uploadImgProfileJson(context,formdata){

        return await this.$api.info.allApi(formdata)
        .then( async () => {
            return await context.dispatch("loadUser")
        })

    },

    async deleteProfile(context,body){

        return await this.$api.info.allApi(body)
        .then( async (response) => {
            return response
        })
    },

    rotateImg(context,formdata){
            
        return this.$api.info.uploadFiles(formdata)
        .then( async () => {
            return await context.dispatch("loadUser")
        })
    },

    async deleteFile(context,body){

        return await this.$api.info.allApi(body)
        .then( async () => {
            await context.dispatch("loadUser")
            return true
        })
    },

    async concludeCreateUser(context, par){

        await Promise.all([
            context.dispatch("uploadFiles",par.formdata_img),
            context.dispatch("uploadFiles",par.filelist_videos),
            context.dispatch("uploadFiles",par.filelist_docs),
        ]);
        
        return true

    },

    async checkPass(context,body_check){

        return await this.$api.info.allApi(body_check)
        .then( data => {
            return data.response.error ? false : true
        })
    },



}
